/**
 * ledgerAdjustmentReasonLabel
 *
 * An adjustment reason named in words: its label in the definition, or its bare id when the definition does not
 * declare it, so a retired reason still reads. Never undefined. Consumers: `ledgerProposalProblem` here,
 * `ledgerPostTransactions` in functions, and `ledgerAccountName` and `ledgerTransactionKindText` in react.
 */

import type { LedgerDefinition } from '../System.Ledger.Definition.types';

export const ledgerAdjustmentReasonLabel = (
    definition: Pick<LedgerDefinition, 'adjustmentReasons'>,
    reasonId: string,
): string => definition.adjustmentReasons.find((reason) => reason.reasonId === reasonId)?.label ?? reasonId;
